module.exports = __webpack_public_path__ + "static/media/luonda.0d8d6b76.webp";